// Save data to LocalStorage
export const saveToLocalStorage = (key, data) => {
  try {
    const serializedData = JSON.stringify(data);
    localStorage.setItem(key, serializedData);
    return { success: true };
  } catch (error) {
    console.error('Error saving to localStorage:', error);
    return { success: false, error: error.message };
  }
};

// Load data from LocalStorage
export const loadFromLocalStorage = (key) => {
  try {
    const serializedData = localStorage.getItem(key);
    if (serializedData === null) {
      return null;
    }
    return JSON.parse(serializedData);
  } catch (error) {
    console.error('Error loading from localStorage:', error);
    return null;
  }
};

// Update data in LocalStorage
export const updateLocalStorage = (key, data) => {
  try {
    const existingData = loadFromLocalStorage(key);

    if (Array.isArray(existingData) && Array.isArray(data)) {
      // If both are arrays, merge them
      const updatedData = [...existingData, ...data];
      saveToLocalStorage(key, updatedData);
    } else if (typeof existingData === 'object' && typeof data === 'object') {
      // If both are objects, merge them
      const updatedData = { ...existingData, ...data };
      saveToLocalStorage(key, updatedData);
    } else {
      // Otherwise, replace the data
      saveToLocalStorage(key, data);
    }

    return { success: true };
  } catch (error) {
    console.error('Error updating localStorage:', error);
    return { success: false, error: error.message };
  }
};

// Delete specific item from LocalStorage array by id
export const deleteFromLocalStorage = (key, id) => {
  try {
    const data = loadFromLocalStorage(key);

    if (Array.isArray(data)) {
      const filteredData = data.filter(item => item.id !== id);
      saveToLocalStorage(key, filteredData);
      return { success: true };
    } else if (typeof data === 'object' && data !== null) {
      // If it's an object, delete the property
      delete data[id];
      saveToLocalStorage(key, data);
      return { success: true };
    } else {
      // If key matches, remove entire key
      if (key === id) {
        localStorage.removeItem(key);
        return { success: true };
      }
      return { success: false, error: 'Data is not an array or object' };
    }
  } catch (error) {
    console.error('Error deleting from localStorage:', error);
    return { success: false, error: error.message };
  }
};

// Clear all data from LocalStorage
export const clearLocalStorage = () => {
  try {
    localStorage.clear();
    return { success: true };
  } catch (error) {
    console.error('Error clearing localStorage:', error);
    return { success: false, error: error.message };
  }
};

// Get all keys from LocalStorage
export const getAllKeys = () => {
  try {
    return Object.keys(localStorage);
  } catch (error) {
    console.error('Error getting keys from localStorage:', error);
    return [];
  }
};

// Initialize default data if not exists
export const initializeDefaultData = () => {
  const keys = ['users', 'companies', 'jobs', 'applications', 'reviews', 'aiMatches'];

  keys.forEach(key => {
    if (!loadFromLocalStorage(key)) {
      saveToLocalStorage(key, []);
    }
  });
};
